import React from "react";

import { Calendar as CalendarIcon } from "react-feather";
import { Grid, TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { createFakeEvent } from "@ds-developer/frontend";

import { InsuranceFormFieldsProps } from "../types";

const InsuranceFormFields: React.FC<InsuranceFormFieldsProps> = ({
  values,
  onInsuranceStartDateChange = () => {},
  onInsuranceEndDateChange = () => {},
  onCertificateNumberChange = () => {},
  errors,
}) => {
  const handleStartDateChange = (date: MaterialUiPickersDate | null) => {
    const event = createFakeEvent("insuranceStartDate", date as Date);
    onInsuranceStartDateChange(event);
  };

  const handleEndDateChange = (date: MaterialUiPickersDate | null) => {
    const event = createFakeEvent("insuranceEndDate", date as Date);
    onInsuranceEndDateChange(event);
  };

  return (
    <Grid container spacing={3}>
      <React.Fragment>
        <Grid item xs={12}>
          <TextField
            id="vehicle-form-insurance-certificate-number"
            fullWidth
            label="Certificate Number"
            variant="outlined"
            name="certificateNumber"
            onChange={onCertificateNumberChange}
            value={values.certificateNumber || ""}
            error={Boolean(errors?.certificateNumber)}
            inputProps={{ "data-test": "vehicle-form-certificate-number" }}
          />
        </Grid>

        <Grid item xs={12}>
          <KeyboardDatePicker
            id="vehicle-form-insurance-start-date"
            fullWidth
            label="Insurance start date (dd/ mm / yyyy)"
            onChange={handleStartDateChange}
            value={values?.insuranceStartDate || null}
            variant="inline"
            format="dd/MM/yyyy"
            inputVariant="outlined"
            error={Boolean(errors?.insuranceStartDate)}
            disableToolbar
            keyboardIcon={<CalendarIcon />}
            inputProps={{ "data-test": "vehicle-form-insurance-start-date" }}
          />
        </Grid>

        <Grid item xs={12}>
          <KeyboardDatePicker
            id="vehicle-form-insurance-end-date"
            fullWidth
            label="Insurance end date (dd/ mm / yyyy)"
            onChange={handleEndDateChange}
            value={values?.insuranceEndDate || null}
            variant="inline"
            format="dd/MM/yyyy"
            inputVariant="outlined"
            error={Boolean(errors?.insuranceEndDate)}
            disableToolbar
            keyboardIcon={<CalendarIcon />}
            inputProps={{ "data-test": "vehicle-form-insurance-end-date" }}
          />
        </Grid>
      </React.Fragment>
    </Grid>
  );
};

export default InsuranceFormFields;
